/**
 * Formats a date string or object into IST (Indian Standard Time)
 * @param {string|Date} dateSource - The date to format
 * @param {Object} options - Intl.DateTimeFormat options
 * @returns {string} Formatted date/time string
 */
export const formatIST = (dateSource, options = {}) => {
    if (!dateSource) return '';
    
    // If it's a string and seems to be an ISO format without timezone, append 'Z' to treat as UTC
    let finalDateSource = dateSource;
    if (typeof dateSource === 'string' && !dateSource.includes('Z') && !dateSource.includes('+')) {
        finalDateSource = dateSource.includes(' ') ? dateSource.replace(' ', 'T') + 'Z' : dateSource + 'Z';
    }
    
    const date = new Date(finalDateSource);
    
    // Default options for time
    const defaultOptions = {
        timeZone: 'Asia/Kolkata',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        ...options
    };

    return date.toLocaleString('en-IN', defaultOptions);
};

/**
 * Formats a date into a full IST date-time string
 */
export const formatISTFull = (dateSource) => {
    return formatIST(dateSource, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
};
